const l = {
  name: "CellularFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 0H20V24H24V0Z" fill="currentColor"/>
<path d="M17.33 6H13.33V24H17.33V6Z" fill="currentColor"/>
<path d="M10.67 12H6.67001V24H10.67V12Z" fill="currentColor"/>
<path d="M4 18H0V24H4V18Z" fill="currentColor"/>
</svg>
  `
};
export {
  l as CellularFilled
};
